<template>
  <div class="lnb">
    <div class="lnbLogo">
      <router-link to="/dashboard">
        <img src="@/assets/images/logo.png" alt="logo" />
      </router-link>
    </div>
    <el-row class="tac mainMenu">
      <el-col :span="12">
        <el-menu class="el-menu-vertical-demo" :default-active="navbarState">
          <el-menu-item index="0">
            <router-link to="/dashboard">
              <span>
                <i class="el-icon-s-home"></i>
                대시보드
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="5">
            <router-link to="/business-info">
              <span>
                <i class="el-icon-office-building"></i>
                업체 정보
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="2">
            <router-link to="/products">
              <span>
                <i class="el-icon-goods"></i>
                상품 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-submenu index="1">
            <template slot="title">
              <span>
                <i class="el-icon-date"></i>
                예약 관리
              </span>
            </template>
            <el-menu-item index="1-1">
              <router-link to="/schedules">
                <span>예약 목록</span>
              </router-link>
            </el-menu-item>
            <el-menu-item index="1-2">
              <router-link to="/booking-settings">
                <span>예약 설정</span>
              </router-link>
            </el-menu-item>
          </el-submenu>
          <el-menu-item index="3">
            <router-link to="/estimates">
              <span>
                <i class="el-icon-document"></i>
                견적 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="7">
            <router-link to="/point-management">
              <span>
                <i class="el-icon-coin"></i>
                포인트 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="4">
            <router-link to="/reviews">
              <span>
                <i class="el-icon-star-off"></i>
                리뷰 관리
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="6">
            <router-link to="/notifications">
              <span>
                <i class="el-icon-bell"></i>
                알림
                <el-badge
                  v-if="unreadNotificationCount > 0"
                  :value="unreadNotificationCount"
                  class="mark"
                />
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="9">
            <router-link to="/chats">
              <span><i class="el-icon-chat-dot-round"></i> 채팅 관리</span>
            </router-link>
          </el-menu-item>
          <el-menu-item index="8">
            <router-link to="/notices">
              <span>
                <i class="el-icon-message-solid"></i>
                공지사항
              </span>
            </router-link>
          </el-menu-item>
          <el-menu-item>
            <router-link to @click.native="logout">
              <span>
                <i class="el-icon-switch-button"></i>
                로그아웃
              </span>
            </router-link>
          </el-menu-item>
        </el-menu>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["navbarState", "unreadNotificationCount"]),
  },
  methods: {
    logout() {
      this.$confirm("로그아웃 하시겠습니까?", {
        confirmButtonText: "확인",
        cancelButtonText: "취소",
        center: true,
      }).then(() => {
        this.$store.dispatch("LOGOUT");
      });
    },
  },
};
</script>
